import React, { useEffect, useRef, useState } from "react"
import style from "./DropDown.module.scss"
import dropdownImg from "../../../assets/icons/v-more.svg";

const DropDown = (props) => {

    const wrapperRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false)

    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    let i = 0;

    return (
        <React.Fragment>
            <div className={style.dropdownWrapper} ref={wrapperRef}>

                <div onClick={() => {
                    setShowDropdown(!showDropdown)
                }}>
                    <div className={style.imageContainer}>
                        <img src={dropdownImg} />
                    </div>
                    <div
                        className={showDropdown ? (typeof props.isLeft === "undefined" || !props.isLeft ? style.dropdown : style.dropdownLeft) : style.deactiveDropdown}>


                        {props.items ?
                            <div>
                                {props.items.map((item, index) =>
                                    <div
                                        key={index}
                                        className={!item.disable ? style.box : style.disableBox}
                                        onClick={() => {
                                            !item.disable && item.onclick();
                                            setShowDropdown(false)
                                        }}
                                        onMouseDown={() => item.modalOpen()}
                                    >
                                        {item.name}
                                        {
                                            typeof item.tooltip !== "undefined" && item.tooltip &&
                                            <div className={style.tooltip}>
                                                <div className={style.triangle}></div>
                                                <div className={style.rectangle}>{item.tooltip}</div>
                                            </div>
                                        }
                                    </div>
                                )}
                            </div>
                            : null}

                    </div>
                </div>

            </div>
        </React.Fragment>
    );
}

export default DropDown;

/*

*
 */
